import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import dayjs from 'dayjs';
import { GlobalToken } from 'antd';

import EcoplantLogo from '@/comp/common/icons/EcoplantLogo';

const ReportsHeader = observer(() => {
  return (
    <Container>
      <div className="page-container">
        <div className="logo">
          <EcoplantLogo />
        </div>
        <div className="date-container">{dayjs().format('D/M/YYYY')}</div>
      </div>
    </Container>
  );
});

const Container = styled.div<{ theme: { token: GlobalToken } }>`
  .logo {
    position: absolute;

    svg {
      height: 25px;
      margin-top: ${({ theme: { token } }) => token.marginXS}px;
      width: auto;
    }
  }

  .date-container {
    position: absolute;
    right: 25px;
    padding-top: ${({ theme: { token } }) => token.padding}px;
  }

  height: 70px;
  background-color: ${({ theme: { token } }) => token.colorBgElevated};
`;

export default ReportsHeader;
